import React from "react"
import {
  FormTableWrapper,
  TableBody,
  WhatIfTableCell,
  TableHead,
  WhatIfTableHeaderCell,
  WhatIfTableRow,
  Fieldset,
  Legend,
  WhatIfTableFooter,
  WhatIfTableFooterRow,
  WhatIfTableFooterCell,
} from "../../styles"
import FormInput from "../FormInput/FormInput"
import PropTypes from "prop-types"

import {
  getFieldIsInvalid,
  getValidationMessage
} from "../../../utils/utils"

function WhatIfTable({ rows, columns, onChange, label, id, footers }) {
  return (
    <Fieldset>
      {label && <Legend>{label}</Legend>}
      <FormTableWrapper>
        {columns && (
          <TableHead  highlightHeader={true}>
            <WhatIfTableRow>
              <WhatIfTableHeaderCell></WhatIfTableHeaderCell>
              {columns.map((column) => (
                <WhatIfTableHeaderCell key={`${id}-column-${column.label}`}>
                  {column.label}
                </WhatIfTableHeaderCell>
              ))}
            </WhatIfTableRow>
          </TableHead>
        )}
        {rows && (
          <TableBody>
            {rows.map((row, index) => (
              <WhatIfTableRow key={`row-${row.values}-${row.field}-${index}`}>
                <WhatIfTableHeaderCell>{row.label}</WhatIfTableHeaderCell>
                {columns.map((column, index) => {
                return (<WhatIfTableCell  key={`column-${row.field}-cell-${index}-${row.values}`} color={index === 0 ? "#55585A" : row.values[column.subsection] > 0 ? "green" : "red"} alignment={"center"} >

                    {column.readOnly ? ( <>{row.values[column.subsection].toLocaleString() || ""}</>) : ( <FormInput
                      {...row}
                      id={row.field}
                      type={row.type ? row.type : "text"}
                      label={null}
                      onChange={(value) =>
                        onChange(row.field, column.subsection, value)
                      }
                      aria-label={`${row.label} for ${column.label}`}
                      value={row.values[column.subsection] || ""}
                      aria-invalid={getFieldIsInvalid(row.values[column.subsection],  row.type, {...row} )}
                      validationText={getValidationMessage(row.values[column.subsection], row.type, { ...row})}
                    />)}
                   
                  </WhatIfTableCell>) }
                )}
              </WhatIfTableRow>
            ))}
          </TableBody>
        )}
        {footers && (
        <WhatIfTableFooter>
              <WhatIfTableFooterRow data-testid={"footers-row"}>
                {footers.map((cell, i) => (
                  <WhatIfTableFooterCell key={`footers-cell-${i}`} alignment={"center"}>
                    {cell}
                  </WhatIfTableFooterCell>
                ))}
              </WhatIfTableFooterRow>

        </WhatIfTableFooter>
      )}
      </FormTableWrapper>
    </Fieldset>
  )
}

WhatIfTable.propTypes = {
  /** An array of columns. Assumes that the table will have all cells in a row with the same type of field */
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      /** a unique subsection name for the header **/
      subsection: PropTypes.string,
      /** the display label for the header **/
      label: PropTypes.string,
    })
  ),
  /** An array of rows. Each row accepts tyhe below, but also can accept anything an input can accept, like aria attributes and so on */
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      /** A unique field name for the row **/
      field: PropTypes.string,
      /** The display label for that row */
      label: PropTypes.string,
      /** The type of input for that row */
      type: PropTypes.string,
      /** Field values - an object keyed by column id, e.g. column1: "the value", column2: "the other value" */
      values: PropTypes.object,
    })
  ),
  /** Called on change of value of an input. Gets called with the row ID, the column ID, and the new value */
  onChange: PropTypes.func,
}

export default WhatIfTable
